module.exports = __webpack_public_path__ + "static/media/ai_man.80fb9562.jpg";